import { selectClasses } from "@mui/material/Select";
import { DROPDOWN_SURFACE } from "src/theme/dropdownSurface";

export const TAGS_FAMILY_SEPARATOR = ":";
export const MAX_TAGS_PER_GROUP = 50;
export const MIN_SEARCH_LENGTH = 2;
export const MAX_VISIBLE_SELECTED_CHIPS = 3;
export const SELECTED_COUNT_THRESHOLD_FOR_LABEL = 2;
export const SELECTED_ONLY_SWITCH_MIN_TAGS = 10;

export const ADDITIONAL_TAGS: { name: string; tag_id: number }[] = [
  // {
  //   name: "Any Tag",
  //   tag_id: 0, //tag = 0  represents all tags
  // },
  // {
  //   name: "No Tags",
  //   tag_id: -1, //tag = -1 represents no tags
  // },
];

export const FORM_CONTROL_STYLES = {
  m: 0,
  minWidth: 170,
  maxWidth: 500,
} as const;

export const SELECT_SELECT_STYLES = {
  pl: 1,
  pr: 2,
  overflow: "hidden",
} as const;

export const SELECT_STYLES = {
  // Target selectClasses.select — that node owns the visible padding
  // (`8.5px 14px` from MUI size="small"). Styles on OutlinedInput
  // cannot win that specificity fight.
  [`& .${selectClasses.select}`]: SELECT_SELECT_STYLES,
  [`& .${selectClasses.icon}`]: {
    backgroundColor: "background.paper",
    borderRadius: "50%",
  },
};

export const MENU_PROPS = {
  autoFocus: false,
  anchorOrigin: {
    vertical: "bottom" as const,
    horizontal: "right" as const,
  },
  transformOrigin: {
    vertical: "top" as const,
    horizontal: "right" as const,
  },
  slotProps: {
    paper: {
      sx: DROPDOWN_SURFACE,
    },
  },
  // NOTE: dead config — `PaperProps` are the Paper's own props, so a nested
  // `slotProps.paper` here never reaches the Paper (its maxHeight/width:400 are not
  // applied today). Left as-is intentionally; the effective paper styling is the
  // `slotProps.paper` above. Do not "fix" this by folding width:400 in — it would
  // visibly widen the dropdown.
  PaperProps: {
    slotProps: {
      paper: {
        style: {
          maxHeight: 400,
          minWidth: 400,
          width: 400,
        },
      },
    },
  },
} as const;

export const EMPTY_STATE_TEXT = "No tags found";

export const OVERFLOW_MESSAGE_TEMPLATE = (count: number): string =>
  `… and ${count} more (type to search)`;

export const SELECT_LABEL_ID = "global_tags_filter";
export const SELECT_TEST_ID = "app-filters--tags-select";
